import {View} from 'MWC';
import tpl from '../templates/TextAboveFooter.jsx';
import {api, apiback} from '../../../../config';
import buildUrl from '../../../../helpers/utils/buildGetURLWithParams';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            where_by: ['path'],
            search_by: [location.pathname],
            widgetName: 'text_above_footer',
            data: {}
        };
    }

    componentDidMount() {}

    checkWidget = () => {
        const {where_by, search_by} = this.state,
            pageParams = {where_by, search_by};
        const url = buildUrl(apiback('API_PAGES'), pageParams);

        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                if (data.length > 0) {
                    const widget = data[0].pageWidgets.find(
                        el => el.code === this.state.widgetName
                    );
                    if (widget) {
                        this.setState({
                            data: widget ? widget.data[0] : {},
                            release: widget ? widget.data[0].release : false,
                            prod: widget ? widget.data[0].prod : false
                        });
                    }
                }
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    static defaultProps = {
        isUa: true
    };
}
